import { TrelloWindow } from '@trello/window-types';

declare const window: TrelloWindow;

const loaders: { [key: string]: Promise<void> } = {};

export async function loadBundle(bundle: string) {
  if (bundle in loaders) {
    return loaders[bundle];
  }

  if (!(bundle in window.__bundles)) {
    throw new Error('Bundle not supported');
  }

  loaders[bundle] = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.crossOrigin = 'anonymous';

    script.onerror = () => {
      reject(new Error('Could not load bundle'));
    };

    script.onload = () => {
      resolve();
    };

    document.head.appendChild(script);
    script.src = window.__bundles[bundle];
  });

  return loaders[bundle];
}
